import React, { SFC } from 'react'
import ActionData from '../../../types/ActionData'
import { Button, Card, Col, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.css'

type Props = {
  confirmPasswordError: boolean
  loadingIcon: object
  pageType: string
  resetPassword: string
  resetPasswordConfirm: string
  resultText: string
  updatePassword: ActionData
	updatingPassword: boolean
	validPassword: boolean
  onChangeField: (e: any, name:string) => void
  onClearPassword: (e: any) => void
  onUpdatePassword: (e: any) => void
}

const SetPassword: SFC<Props> = (props) => {
  const {confirmPasswordError, loadingIcon, pageType, resetPassword, resetPasswordConfirm, resultText, updatePassword, updatingPassword, onChangeField, validPassword, onClearPassword, onUpdatePassword} = props

	let passwordError = (<div></div>)
	
  if(!validPassword)
		passwordError = (
			<div className="loading-error-msg-2">
				<FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon" size="3x"/>
				<div>
					<span className="loading-error-msg-span">Sorry, the password does not meet the password policy requirements.</span>
					<ul style={{fontSize:'0.75rem', marginTop:'0.5rem'}}>
						<li>At least 8 characters.</li>
						<li>At least one number and letter.</li>
						<li>At least one special character !@#$%&*()</li>
					</ul>
					<span>Please check it and try again.</span>
				</div>
			</div>
		)

  let setPwdTitle = (<span className="login-warning-text">Reset your password.</span>)
  if(pageType==='activate'){
		setPwdTitle = (
			<div>
				<FontAwesomeIcon icon={['far', 'check-circle']} color="#75b465" className="login-validate-icon" />
				<span className="login-validate-title">Thanks for validating your email.</span>
				<span className="login-validate-subtitle">Next, set your password below.</span>
			</div>
		)
  }

  let errorMessage = (<div></div>)
  if(confirmPasswordError)
		errorMessage = (
			<Form.Text className="login-error-msg">
			<FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon"/>Your passwords do not match.
			</Form.Text>
		)
  
  return (
		<Card className={!validPassword?"set-pwd-card":"login-card"}>
			<Card.Body>
				{updatingPassword ? 
					updatePassword.loading || updatePassword.error!== false ? (
						<div className="login-loading-container">
							{loadingIcon}
							<span className="login-loading-text">{resultText}</span>
						</div>
					) : updatePassword.success ? (
						<div className="login-card-body">
							<div className="login-success-container">
								<FontAwesomeIcon icon={['far', 'check-circle']} color="#75b465" className="login-success-icon" />
								<span className="login-success-text">Your password has been set.</span>
							</div>
							<div className="login-button-grp">
								<Link to="/login">
								<Button id="login-view-btn">
									Go to Login
								</Button>
								</Link>
							</div>
						</div>
					) : (
						<div></div>
					) : (
						<div className="login-card-body">
							{setPwdTitle}
							{pageType==='activate'?(<hr className="login-validate-line"/>):(<div></div>)}
							{passwordError}
							<Form className='login-form'>
								<Form.Group as={Col} lg={12} md={12} sm={12} xs={12}>
									<Form.Label>Password</Form.Label>
									<Form.Control size="lg" placeholder="Set your password" className="login-ipt" type="password" isInvalid={!validPassword} value={resetPassword} onChange={(e: any)=>{onChangeField(e, 'resetPassword')}}/>
								</Form.Group>
								<Form.Group as={Col} lg={12} md={12} sm={12} xs={12}>
									<Form.Label>Password</Form.Label>
									<Form.Control size="lg" placeholder="Re-enter your password" className="login-ipt" type="password" isInvalid={confirmPasswordError||!validPassword} value={resetPasswordConfirm} onChange={(e: any)=>{onChangeField(e, 'resetPasswordConfirm')}}/>
									{errorMessage}
								</Form.Group>
							</Form>
							<div className='login-btn-grp'>
								<Button variant="secondary" id="login-cancel-btn" onClick={onClearPassword}>
									Clear
								</Button>
								<Button id="login-btn" disabled={resetPassword===''||resetPasswordConfirm===''||confirmPasswordError} onClick={onUpdatePassword}>
									Submit
								</Button>
							</div>
						</div>
					)}
				</Card.Body>
			</Card>
		)
}
export default SetPassword
